// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core from "@material-ui/core";
import * as User_Context$DvmAdminFrontendFr from "../../../../context/user/User_Context.bs.js";
import * as Order_Detail_Utils$DvmAdminFrontendFr from "../Order_Detail_Utils.bs.js";
import * as Order_Detail_Styles$DvmAdminFrontendFr from "../Order_Detail_Styles.bs.js";
import * as Order_Detail_Error_Comment$DvmAdminFrontendFr from "./Order_Detail_Error_Comment.bs.js";
import * as Order_Detail_Types_Comment$DvmAdminFrontendFr from "../Order_Detail_Types_Comment.bs.js";
import * as Order_Detail_Bonus_Box_Fleet$DvmAdminFrontendFr from "./Order_Detail_Bonus_Box_Fleet.bs.js";
import * as Order_Detail_Bonus_Box_NonFleet$DvmAdminFrontendFr from "./Order_Detail_Bonus_Box_NonFleet.bs.js";
import * as Order_Detail_Bonus_Derogate_Button$DvmAdminFrontendFr from "./derogate/Order_Detail_Bonus_Derogate_Button.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Comment$DvmAdminFrontendFr from "./dealerRequest/Order_Detail_Bonus_DealerRequest_Comment.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Edit_Buttons$DvmAdminFrontendFr from "./dealerRequest/edits/Order_Detail_Bonus_DealerRequest_Edit_Buttons.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Documents_Button$DvmAdminFrontendFr from "./dealerRequest/viewDocuments/Order_Detail_Bonus_DealerRequest_Documents_Button.bs.js";

function Order_Detail_Bonus_Box(Props) {
  var bonus = Props.bonus;
  var color = Props.color;
  var openModal = Props.openModal;
  var archived = Props.archived;
  var order = Props.order;
  var documentsResult = Props.documentsResult;
  var dealerRequests = Props.dealerRequests;
  var orderId = Props.orderId;
  var reloadPage = Props.reloadPage;
  var kind = Props.kind;
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var selectedRole = match[0].selectedRole;
  var match$1 = React.useState(function () {
        
      });
  var setFilteredRequest = match$1[1];
  var filteredRequest = match$1[0];
  React.useEffect((function () {
          if (typeof dealerRequests !== "number" && dealerRequests.TAG === /* Ok */0) {
            var documents = dealerRequests._0;
            Curry._1(setFilteredRequest, (function (param) {
                    return Belt_List.getBy(documents, (function (x) {
                                  return x.actionId === Belt_Option.getWithDefault(bonus.actionId, "");
                                }));
                  }));
          }
          
        }), [dealerRequests]);
  var editButtons = function (orderType) {
    if (Order_Detail_Utils$DvmAdminFrontendFr.rolesCanDealerRequest(selectedRole)) {
      return React.createElement(Order_Detail_Bonus_DealerRequest_Edit_Buttons$DvmAdminFrontendFr.make, {
                  order: order,
                  documentsResult: documentsResult,
                  origBonus: bonus,
                  orderType: orderType,
                  orderId: orderId,
                  reloadPage: reloadPage,
                  filteredRequest: filteredRequest
                });
    } else {
      return null;
    }
  };
  return Belt_Option.mapWithDefault(bonus.actionId, null, (function (param) {
                var tmp = {
                  openModal: openModal,
                  order: order,
                  state: bonus.resultActionStatus
                };
                if (bonus.requestType !== undefined) {
                  tmp.requestType = Caml_option.valFromOption(bonus.requestType);
                }
                var comment = bonus.messages;
                return React.createElement(Core.Grid, {
                            children: null,
                            className: Order_Detail_Styles$DvmAdminFrontendFr.helpersBoxNew,
                            container: true,
                            spacing: 1,
                            style: {
                              borderLeft: "4px solid " + color + ""
                            }
                          }, React.createElement(Core.Grid, {
                                children: null,
                                container: true,
                                direction: "column",
                                item: true
                              }, kind === "nonfleet" ? React.createElement(Order_Detail_Bonus_Box_NonFleet$DvmAdminFrontendFr.make, {
                                      bonus: bonus,
                                      archived: archived,
                                      filteredRequest: filteredRequest
                                    }) : React.createElement(Order_Detail_Bonus_Box_Fleet$DvmAdminFrontendFr.make, {
                                      bonus: bonus,
                                      archived: archived,
                                      filteredRequest: filteredRequest
                                    }), React.createElement(Order_Detail_Bonus_Derogate_Button$DvmAdminFrontendFr.make, tmp), React.createElement(Order_Detail_Bonus_DealerRequest_Documents_Button$DvmAdminFrontendFr.make, {
                                    documentsResult: documentsResult,
                                    actionId: bonus.actionId
                                  }), React.createElement(Order_Detail_Bonus_DealerRequest_Comment$DvmAdminFrontendFr.make, {
                                    dealerRequests: dealerRequests,
                                    actionId: bonus.actionId
                                  }), comment !== undefined ? Belt_Array.map(Belt_List.toArray(comment), (function (comment) {
                                        return React.createElement(Order_Detail_Error_Comment$DvmAdminFrontendFr.make, {
                                                    comment: comment,
                                                    order: order,
                                                    key: Order_Detail_Types_Comment$DvmAdminFrontendFr.toString(comment.messageId)
                                                  });
                                      })) : null), Belt_Option.mapWithDefault(order.header.orderOrderType, null, (function (orderType) {
                                  return Belt_Option.mapWithDefault(bonus.resultActionStatus, editButtons(orderType), (function (state) {
                                                if (state === /* NOBONUS */3 || state === /* PREINVOICED */5 || state === /* PAID */4) {
                                                  return null;
                                                } else {
                                                  return editButtons(orderType);
                                                }
                                              }));
                                })));
              }));
}

var make = Order_Detail_Bonus_Box;

export {
  make ,
}
/* react Not a pure module */
